module.exports = __webpack_public_path__ + "static/media/ProfilePic.6b88a696.jpg";